import React from 'react';

export const pastEventsIntro = {
  heading: 'Featured',
  headingMobile: 'Past Events',
  subHeading: 'Past Events',
  paragraph: '',
  paragraphMobile: '',
};
